export default "__VITE_ASSET__CBOvSHIi__"